import { Component } from '../component/component';

export class SwitchItem extends Component {

	constructor(parent) {
		super();
		this.node = this.getNode();
		this.parent = parent;
		this.open = false;
		this.init();
		this.addListener();
	}

	getTemplate() {
		let template;
		template = `
        <div class="conf__switch">
            <span class="conf__switch-btn"></span>
            <span class="conf__switch-label"></span>
        </div>
        `;
		return template;
	}

	init() {
		this.parent.appendChild(this.node);
		this.label = this.node.querySelector('.conf__switch-label');
		this.label.innerHTML = productSheet.conf.CLOSE_VIEW;
	}

	addListener() {
		this.onClick = this.onClick.bind(this);
		this.node.addEventListener('click', this.onClick);
	}

	onClick(event) {
		this.toggle();
		this.emit('switch', { open: this.open });
	}

	toggle() {
		if (this.open) {
			this.node.classList.remove('conf__switch--on');
			this.label.innerHTML = productSheet.conf.CLOSE_VIEW;
			this.open = false;
		} else {
			this.node.classList.add('conf__switch--on');
			this.label.innerHTML = productSheet.conf.OPEN_VIEW;
			this.open = true;
		}
	}

	destroy() {
		this.node.removeEventListener('click', this.onClick);
	}
}
